export const ADMINS_TARGETS = {
  ADD_ADMIN: 'addAdmin'
};

export const ADMINS_DEFAULT_STATE = {
  [ADMINS_TARGETS.ADD_ADMIN]: null
};
